import { oc } from "@orpc/contract";
import { z } from "zod";
import { ConfirmPayrollExportResponseSchema } from "@hourly/api/payrollExport";
const confirmPayrollExport = oc
    .route({
    method: "POST",
    path: "/payroll-exports/{id}/confirm",
    summary: "Confirm a payroll export, marking linked timecards as exported",
    tags: ["PayrollExport"],
})
    .input(z.object({
    id: z.uuid(),
}))
    .output(ConfirmPayrollExportResponseSchema);
const getDownloadUrl = oc
    .route({
    method: "GET",
    path: "/payroll-exports/{id}/download-url",
    summary: "Get presigned download URL for a payroll export CSV",
    tags: ["PayrollExport"],
})
    .input(z.object({
    id: z.uuid(),
}))
    .output(z.object({ url: z.string() }));
export const payrollExportContract = {
    confirm: confirmPayrollExport,
    getDownloadUrl,
};
//# sourceMappingURL=payrollExport.js.map